module.exports = __webpack_public_path__ + "d308073b/img/google.68f3823e.svg";